export default __webpack_public_path__ + "static/media/hills-hops-cycling-crew.03d9edc1.jpg";